@if (order) {
  <div class="main-window">
    <!-- ================= TOP SECTION ================= -->
    <div class="section-row">
      <!-- LEFT BLOCK -->
      <div class="block" style="width: 275px">
        <div class="field-row">
          <span class="lbl-red" style="width: 40px">Order:</span>
          <div style="display: flex; align-items: center; gap: 2px">
            <input type="text" [(ngModel)]="order.OrderNo" style="width: 70px; font-weight: bold" />
            <button type="button" class="search-btn" (click)="onSearchOrder()">
              <span class="material-icons">search</span>
            </button>
          </div>
          <span style="color: blue; font-weight: bold; margin-left: 10px">Open</span>
        </div>
        <table class="pkg-table">
          <tr>
            <th align="left">Package Type</th>
            <th width="30">Qty</th>
            <th width="30">Size</th>
          </tr>
          @for (p of packages; track p) {
            <tr>
              <td class="pkg-type">{{ p.PackageType }}</td>
              <td class="pkg-qty">{{ p.Qty }}</td>
              <td class="pkg-size">{{ p.Size || 0 }}</td>
            </tr>
          }
        </table>
        <div class="field-row">
          <span class="lbl-red">Acct No:</span>
          <input [(ngModel)]="order.AccountNumber" />
        </div>
        <div class="field-row">
          <span class="lbl-red">Caller:</span>
          <input [(ngModel)]="order.Caller" />
        </div>
      </div>
      <!-- CENTER BLOCK -->
      <div class="block" style="flex: 1">
        <div class="field-row">
          <span class="lbl-red">Service:</span>
          <input [(ngModel)]="order.ServiceType" style="width: 260px" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">POD:</span>
          <input [(ngModel)]="order.POD" style="width: 150px" />
        </div>
        <div class="field-row">
          <span class="lbl">Weight:</span>
          <input [(ngModel)]="order.Weight" style="width: 60px" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">Waiting Time (Min) Pickup:</span>
          <input [(ngModel)]="order.WaitingTimePickup" style="width: 50px" />
        </div>
        <div class="field-row">
          <span class="lbl">DIM:</span>
          <input [(ngModel)]="order.CubedWeight" style="width: 60px" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">Delivery:</span>
          <input [(ngModel)]="order.DeliveryTimeMinutes" style="width: 40px" />
        </div>
        <div class="field-row"></div>
        <div class="field-row">
          <span class="lbl">Name:</span>
          <input [(ngModel)]="order.Company" />
        </div>
        <div class="field-row">
          <span class="lbl">Phone:</span>
          <input [(ngModel)]="order.Phone" style="width: 140px" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">Department:</span>
          <input [(ngModel)]="order.Department" style="width: 120px" />
        </div>
      </div>
      <!-- RIGHT BLOCK -->
      <div class="block" style="width: 215px">
        <div class="field-row">
          <span class="lbl">Delivered:</span>
          <input [(ngModel)]="order.DeliveryArrivalTime" />
        </div>
        <div class="field-row">
          <span class="lbl">Waybill:</span>
          <input [(ngModel)]="order.WaybillNumber" />
        </div>
        <div class="field-row">
          <span class="lbl">Picked Up:</span>
          <input [(ngModel)]="order.PickedUp" />
        </div>
        <div class="field-row"></div>
        <div class="field-row">
          <span class="lbl">Code:</span>
          <input [(ngModel)]="order.Code" />
        </div>
        <div class="field-row">
          <span class="lbl">Reference:</span>
          <input [(ngModel)]="order.Reference" />
        </div>
      </div>
    </div>
    <!-- ================= PICKUP / DELIVERY ================= -->
    <div class="section-row">
      <!-- PICKUP -->
      <div class="block" style="flex: 1">
        <div class="blue-title">
          <span style="margin-right: 8px">Pickup</span>
          <input [ngModel]="pickupFullAddress" readonly style="height: 17px; font-weight: normal" />
        </div>
        <div class="addr-grid">
          <span class="lbl-red">Name</span>
          <input [(ngModel)]="order.PickupCompanyName" style="grid-column: 2 / 5" />
          <span style="text-align: right">Code</span>
          <input [(ngModel)]="order.PickupCode" />
          <span class="lbl-red">Street</span>
          <input [(ngModel)]="order.PickupStreet" style="grid-column: 2 / 5" />
          <span style="text-align: right">Unit</span>
          <input [(ngModel)]="order.PickupUnit" />
          <span class="lbl-red">City</span>
          <input [(ngModel)]="order.PickupCity" style="grid-column: 2 / 3" />
          <span style="text-align: right">Province</span>
          <input [(ngModel)]="order.PickupProvince" />
          <span style="text-align: right">PC</span>
          <input [(ngModel)]="order.PickupPostalCode" />
          <span>Contact</span>
          <input [(ngModel)]="order.PickupContact" style="grid-column: 2 / 3" />
          <span style="text-align: right">Phone</span>
          <input [(ngModel)]="order.PickupPhone" style="grid-column: 4 / 7" />
          <span class="lbl-red">Country</span>
          <input [(ngModel)]="order.PickupCountry" style="grid-column: 2 / 3" />
          <span style="text-align: right">Closing</span>
          <div class="win-spin" style="grid-column: 4 / 6">
            <input [(ngModel)]="order.PickupClose" style="border: none" />
            <div class="spin-btns">
              <div class="spin-b">▲</div>
              <div class="spin-b">▼</div>
            </div>
          </div>
          <span style="grid-column: 1">Zone</span>
          <input [(ngModel)]="order.PickupZone" style="grid-column: 2 / 3" />
          <span style="text-align: right">Dispatch</span>
          <input [(ngModel)]="order.PickupDispatchZone" style="grid-column: 4 / 7" />
        </div>
      </div>
      <!-- DELIVERY -->
      <div class="block" style="flex: 1">
        <div class="blue-title">
          <span style="margin-right: 8px">Delivery</span>
          <input [ngModel]="deliveryFullAddress" readonly style="height: 17px; font-weight: normal" />
        </div>
        <div class="addr-grid">
          <span class="lbl-red">Name</span>
          <input [(ngModel)]="order.DeliveryCompanyName" style="grid-column: 2 / 5" />
          <span style="text-align: right">Code</span>
          <input [(ngModel)]="order.DeliveryCode" />
          <span class="lbl-red">Street</span>
          <input [(ngModel)]="order.DeliveryStreet" style="grid-column: 2 / 5" />
          <span style="text-align: right">Unit</span>
          <input [(ngModel)]="order.DeliveryUnit" />
          <span class="lbl-red">City</span>
          <input [(ngModel)]="order.DeliveryCity" style="grid-column: 2 / 3" />
          <span style="text-align: right">Province</span>
          <input [(ngModel)]="order.DeliveryProvince" />
          <span style="text-align: right">PC</span>
          <input [(ngModel)]="order.DeliveryPostalCode" />
          <span>Contact</span>
          <input [(ngModel)]="order.DeliveryContact" style="grid-column: 2 / 3" />
          <span style="text-align: right">Phone</span>
          <input [(ngModel)]="order.DeliveryPhone" style="grid-column: 4 / 7" />
          <span class="lbl-red">Country</span>
          <input [(ngModel)]="order.DeliveryCountry" style="grid-column: 2 / 3" />
          <span style="text-align: right">Closing</span>
          <div class="win-spin" style="grid-column: 4 / 6">
            <input [(ngModel)]="order.DeliveryClose" style="border: none" />
            <div class="spin-btns">
              <div class="spin-b">▲</div>
              <div class="spin-b">▼</div>
            </div>
          </div>
          <span style="grid-column: 1">Zone</span>
          <input [(ngModel)]="order.DeliveryZone" style="grid-column: 2 / 3" />
          <span style="text-align: right">Dispatch</span>
          <input [(ngModel)]="order.DeliveryDispatchZone" style="grid-column: 4 / 7" />
        </div>
      </div>
    </div>
    <!-- ================= DATES / VEHICLE ================= -->
    <div class="section-row">
      <div class="block" style="flex: 1.2">
        <div class="field-row">
          <span class="lbl">Pickup:</span>
          <input [(ngModel)]="order.Pickup" class="date-input" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">Ready:</span>
          <input [(ngModel)]="order.ReadyTime" style="width: 70px" />
        </div>
        <div class="field-row">
          <span class="lbl">Delivery:</span>
          <input [(ngModel)]="order.Delivery" class="date-input" />
          <span style="flex-grow: 1; text-align: right; padding-right: 5px">By:</span>
          <input [(ngModel)]="order.DeliverBy" style="width: 70px" />
        </div>
        <div class="field-row"></div>
        <div class="field-row">
          <input type="checkbox" [(ngModel)]="order.PickupArrivalConfirmed" style="width: 13px; margin-right: 5px" />
          <span style="width: 120px">Pickup Arrival:</span>
          <input [(ngModel)]="order.PickupArrivalTime" style="width: 150px" />
        </div>
        <div class="field-row">
          <input type="checkbox" [(ngModel)]="order.DeliveryArrivalConfirmed" style="width: 13px; margin-right: 5px" />
          <span style="width: 120px">Delivery Arrival:</span>
          <input [(ngModel)]="order.DeliveryArrivalTime" style="width: 150px" />
        </div>
        <div class="field-row"></div>
        <div class="field-row">
          <input type="checkbox" [(ngModel)]="order.InsuranceRequired" style="width: 13px; margin-right: 5px" />
          <span>Req Insurance</span>
          <span style="margin: 0 5px">Value:</span>
          <input [(ngModel)]="order.DeclaredValue" style="width: 60px" />
          <span style="flex-grow: 1; text-align: right">COD:</span>
          <input [(ngModel)]="order.CollectCODAmount" style="width: 140px" />
        </div>
        <div class="field-row">
          <span>Undelivered Reason:</span>
          <input [(ngModel)]="order.UndeliverableReason" style="flex: 1; margin-left: 5px" />
        </div>
      </div>
      <div class="block" style="flex: 1">
        <div class="field-row">
          <span class="lbl-red" style="width: 85px">Vehicle:</span>
          <input [(ngModel)]="order.VehicleType" />
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Dispatch Board:</span>
          <input [(ngModel)]="order.AssignedDispatchBoard" />
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Driver 1:</span>
          <input [(ngModel)]="order.PickupDriver" style="flex: 1" />
          <input [(ngModel)]="order.Driver1Units" style="width: 30px; margin-left: 2px" />
          <span class="lock-icon">🔒</span>
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Driver 2:</span>
          <input [(ngModel)]="order.DeliveryDriver" style="flex: 1" />
          <input [(ngModel)]="order.Driver2Units" style="width: 30px; margin-left: 2px" />
          <span class="lock-icon">🔒</span>
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Driver 3:</span>
          <input [(ngModel)]="order.Driver3" style="flex: 1" />
          <input [(ngModel)]="order.Driver3Units" style="width: 30px; margin-left: 2px" />
          <span class="lock-icon"></span>
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Driver 4:</span>
          <input [(ngModel)]="order.Driver4" style="flex: 1" />
          <input [(ngModel)]="order.Driver4Units" style="width: 30px; margin-left: 2px" />
          <span class="lock-icon"></span>
        </div>
        <div class="field-row">
          <span class="lbl" style="width: 85px">Driver 5:</span>
          <input [(ngModel)]="order.Driver5" style="flex: 1" />
          <input [(ngModel)]="order.Driver5Units" style="width: 30px; margin-left: 2px" />
          <span class="lock-icon"></span>
        </div>
      </div>
    </div>
    <!-- ================= BOTTOM TEXTAREAS ================= -->
    <div class="section-row">
      <!-- LEFT TEXTAREA -->
      <div class="block" style="flex: 1; margin-right: 1px">
        <div style="margin-bottom: 2px">Undelivered Additional Information:</div>
        <textarea [(ngModel)]="order.UndeliveredAdditionalInformation"></textarea>
      </div>
      <!-- RIGHT TEXTAREA -->
      <div class="block" style="flex: 1">
        <div style="margin-bottom: 2px">Instructions:</div>
        <textarea [(ngModel)]="order.Instructions"></textarea>
      </div>
    </div>
  </div>
}

@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
